import React from 'react'
import { Grid, Button, List, ListItem,/*  Divider, */ SvgIcon, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { reduxForm, Field } from 'redux-form';
import "moment/locale/es";

import RenderDateTimePicker from '../Complements/renderDateTimePicker';
import RenderSelectFieldTranvia from '../Complements/RenderSelectFieldTranvia';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
    textField: {
        width: 200,
    },
    margin: {
        margin: theme.spacing(1),
    },
    submit: {
        fontWeight: 'bold',
        fontSize: '0.9rem',
        borderRadius: "10px",
        fontFamily: 'FilsonProBold',

    },
    icon: {
        fill: 'green',
        [theme.breakpoints.up('xs')]: {
            maxWidth: '15%',
            minWidth: '15%'
        },
        [theme.breakpoints.up('sm')]: {
            maxWidth: `14%`,
            minWidth: '14%'
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: `14%`,
            minWidth: '14%'
        },
        [theme.breakpoints.up('lg')]: {
            maxWidth: `14%`,
            minWidth: '14%'
        },
        [theme.breakpoints.up('xl')]: {
            maxWidth: `14%`,
            minWidth: '14%'
        },
    },
    logo: {
        // color: 'green',
        [theme.breakpoints.up('xs')]: {
            maxWidth: `80%`,
            minWidth: `80%`
        },
        [theme.breakpoints.up('sm')]: {
            maxWidth: `80%`,
            minWidth: `80%`
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: `80%`,
            minWidth: `80%`
        },
        [theme.breakpoints.up('lg')]: {
            maxWidth: `80%`,
            minWidth: `80%`
        },
        [theme.breakpoints.up('xl')]: {
            maxWidth: `80%`,
            minWidth: `80%`
        },
    },
    root: {
        flexGrow: 1,
    },


}));

const validate = values => {
    const error = {}
    return error
}

const TranviaForm = props => {

    const classes = useStyles();

    const {
        handleSubmit,
        onCancelAction,
        handleDateStart,
        dateStart,
        handleParameterRateCount,
        parametersTranviaServices,
        onReset
    } = props

    let arrayAux = parametersTranviaServices

    const [count, setCount] = React.useState(0);
    React.useEffect(() => {
        setCount(0)
    }, [onReset])

    const hours = (date) => {
        const dateCopy = new Date();
        dateCopy.setDate(date.getDate());
        dateCopy.setMonth(date.getMonth());
        return dateCopy
    }
    return (
        <div>
            {
                (Object.keys(parametersTranviaServices).length !== 0 && parametersTranviaServices.error !== true) ?
                    <form className={classes.form} onSubmit={handleSubmit}>
                        <Grid container className={classes.root} justifyContent="center" alignItems="center">
                            <Grid item xs={12} md={12} lg={12} xl={12}>
                                {
                                    (arrayAux.horario_servicio) &&
                                    <Field
                                        withFocus
                                        name="dateStart"
                                        id="dateStart"
                                        required
                                        component={RenderDateTimePicker}
                                        date={dateStart}

                                        onDateChange={(e) => {
                                            handleDateStart(e)
                                            if (arrayAux?.horario_servicio.split('-')[0] > moment(e).format('HH:mm')) {
                                                handleDateStart(hours(e))
                                            }
                                            if (arrayAux?.horario_servicio.split('-')[1] < moment(e).format('HH:mm')) {
                                                handleDateStart(hours(e))
                                            }
                                        }}
                                        label="Seleccione fecha y hora de su ticket"
                                        type="date"
                                        fullWidth
                                    />

                                }

                                {
                                    (arrayAux.horario_servicio) &&
                                    <Typography
                                        component="span"
                                        variant="body2"
                                        color="textPrimary"
                                        align='center'
                                    >
                                        El horario disponible es: {arrayAux.horario_servicio}

                                    </Typography>
                                }


                                {
                                    (arrayAux.tarifas) &&
                                    <List >
                                        {
                                            arrayAux.tarifas.map((data, i) => {
                                                return <div key={data.tar_id}>

                                                    <ListItem button alignItems="center" style={{
                                                    }}>
                                                        <SvgIcon viewBox="0 0 122.88 122.88" style={{ color: data.tar_codigoColor }} {...props}>
                                                            <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 122.88 122.88">
                                                                <style type="text/css">
                                                                    {`.st0{fill-rule:evenodd;clip-rule:evenodd;}`}
                                                                </style>
                                                                <g>
                                                                    <path
                                                                        className="st0"
                                                                        d="M1.04,79.96L64.7,16.3c0.55,0.07,1.13-0.1,1.55-0.52c0.42-0.42,0.6-1,0.52-1.55L79.96,1.04c1.39-1.39,3.66-1.39,5.05,0l10.43,10.44c-2.74,4.47-2.17,10.39,1.7,14.26c3.87,3.87,9.79,4.43,14.26,1.7l10.43,10.43c1.39,1.39,1.39,3.66,0,5.05l-13.19,13.19c-0.55-0.07-1.12,0.1-1.55,0.52c-0.42,0.42-0.6,1-0.52,1.55l-63.65,63.65c-1.39,1.39-3.66,1.39-5.05,0L27.5,111.47c2.98-4.51,2.48-10.63-1.48-14.6c-3.97-3.97-10.09-4.46-14.6-1.48L1.04,85.01C-0.35,83.62-0.35,81.35,1.04,79.96L1.04,79.96z M102.27,51.81c0.72-0.72,1.89-0.72,2.61,0c0.72,0.72,0.72,1.89,0,2.61c-0.72,0.72-1.89,0.72-2.61,0C101.55,53.7,101.55,52.53,102.27,51.81L102.27,51.81z M97.44,46.98c0.72-0.72,1.89-0.72,2.61,0c0.72,0.72,0.72,1.89,0,2.61c-0.72,0.72-1.89,0.72-2.61,0C96.72,48.87,96.72,47.7,97.44,46.98L97.44,46.98z M92.61,42.15c0.72-0.72,1.89-0.72,2.61,0c0.72,0.72,0.72,1.89,0,2.61c-0.72,0.72-1.89,0.72-2.61,0C91.89,44.04,91.89,42.87,92.61,42.15L92.61,42.15z M87.78,37.32c0.72-0.72,1.89-0.72,2.61,0c0.72,0.72,0.72,1.89,0,2.61c-0.72,0.72-1.89,0.72-2.61,0C87.06,39.21,87.06,38.04,87.78,37.32L87.78,37.32z M82.95,32.49c0.72-0.72,1.89-0.72,2.61,0c0.72,0.72,0.72,1.89,0,2.61c-0.72,0.72-1.89,0.72-2.61,0C82.23,34.38,82.23,33.21,82.95,32.49L82.95,32.49z M78.12,27.66c0.72-0.72,1.89-0.72,2.61,0c0.72,0.72,0.72,1.89,0,2.61c-0.72,0.72-1.89,0.72-2.61,0C77.4,29.55,77.4,28.38,78.12,27.66L78.12,27.66z M73.29,22.83c0.72-0.72,1.89-0.72,2.61,0c0.72,0.72,0.72,1.89,0,2.61c-0.72,0.72-1.89,0.72-2.61,0C72.57,24.72,72.57,23.55,73.29,22.83L73.29,22.83z M68.46,18c0.72-0.72,1.89-0.72,2.61,0c0.72,0.72,0.72,1.89,0,2.61c-0.72,0.72-1.89,0.72-2.61,0C67.74,19.89,67.74,18.72,68.46,18L68.46,18z M25.45,74.91l39.38-39.38c1.62-1.62,4.27-1.62,5.89,0l18.1,18.1c1.62,1.62,1.62,4.27,0,5.89L49.44,98.9c-1.62,1.62-4.27,1.62-5.89,0l-18.1-18.1C23.83,79.18,23.83,76.53,25.45,74.91L25.45,74.91z"
                                                                    />
                                                                </g>
                                                            </svg>
                                                        </SvgIcon>
                                                        <Field
                                                            withFocus
                                                            name={data.tar_descripcion}
                                                            id={data.tar_descripcion}
                                                            required
                                                            component={RenderSelectFieldTranvia}
                                                            data={data}
                                                            arrayAux={arrayAux}
                                                            handleParameterRateCount={handleParameterRateCount}
                                                            label={data.tar_descripcion}
                                                            type="text"
                                                            fullWidth
                                                            setTotal={(e) => {
                                                                setCount(e.total)
                                                            }}
                                                            onReset={onReset}
                                                        />

                                                    </ListItem>
                                                </div>

                                            })
                                        }
                                    </List>
                                }
                            </Grid>
                            <Grid item xs={12} md={12} lg={12} xl={12} /* alignItems='center' */ /* justifyContent='center'  */>
                                <Typography
                                    component="span"
                                    variant="body2"
                                    style={{ textAlign: 'justify', color: '#1c4c96', fontFamily: 'Roboto-Medium' }}

                                >
                                    {arrayAux.msg_informativo}

                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={12} lg={12} xl={12} /* alignItems='center' */ /* justifyContent='center' */ >
                                <Typography
                                    component="span"
                                    variant="body2"
                                    color="textPrimary"
                                    style={{ textAlign: 'center' }}

                                >
                                    Total a pagar: ${count}

                                </Typography>
                            </Grid>

                            <Grid item xs={6} md={6} style={{
                                paddingLeft: '5px',
                                paddingRight: '5px'
                            }}>
                                <Button variant="contained" type="submit"
                                    fullWidth
                                    color="primary"
                                    disabled={parseFloat(count) > 0 ? false : true}
                                >
                                    Comprar
                                </Button>
                            </Grid>
                            <Grid item xs={6} md={6} style={{
                                paddingLeft: '5px',
                                paddingRight: '5px'
                            }}>
                                <Button variant="contained"
                                    fullWidth
                                    color="primary"
                                    disabled={parseFloat(count) === 0 ? true : false}
                                    onClick={() => onCancelAction()}>
                                    Cancelar
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                    :
                    <div>
                        {parametersTranviaServices.message}
                    </div>
            }
        </div>
    )
}

const TranviaFormReduxForm = reduxForm(
    {
        form: 'TranviaForm',
        validate
    }
)(TranviaForm)
export default TranviaFormReduxForm
